import { Paths } from 'shared/routes/paths';
import { Goal } from 'shared/types/goal';
import { Task } from 'shared/types/task';
import { TaskActionType } from 'shared/types/task-action';
import { getGoalDetailUrl } from 'shared/utils/get-goal-detail-url';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

// An action-timeslot task opens the entity it blocks time for, not the task dialog.
const timeslotDetailPaths: Partial<Record<TaskActionType, Paths>> = {
  [TaskActionType.LifeAreaTimeslot]: Paths.LifeAreaDetail,
  [TaskActionType.TagTimeslot]: Paths.TagDetail,
  [TaskActionType.SmartListTimeslot]: Paths.SmartListDetail,
};

export const getTimeslotDetailUrl = (
  task: Task | undefined,
  goals: Goal[],
): string | null => {
  const actionType = task?.action?.type;
  const metaId = task?.action?.meta.id;
  if (!actionType || !metaId) {
    return null;
  }

  if (actionType === TaskActionType.GoalTimeslot) {
    return getGoalDetailUrl(
      goals.find(({ id }) => id === metaId) ?? { id: metaId },
    );
  }

  const path = timeslotDetailPaths[actionType];

  return path ? replaceUrlParams(path, { id: metaId }) : null;
};
